module.exports = __webpack_public_path__ + "img/various-payment-scenarios.7921fa68.svg";